"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarlyExpedition = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Tags_1 = require("../Tags");
var CardRequirements_1 = require("../CardRequirements");
var Units_1 = require("../../Units");
var AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
var ResourceType_1 = require("../../ResourceType");
var Board_1 = require("../../boards/Board");
var SelectSpace_1 = require("../../inputs/SelectSpace");
var Options_1 = require("../Options");
var EarlyExpedition = (function (_super) {
    __extends(EarlyExpedition, _super);
    function EarlyExpedition() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.EARLY_EXPEDITION,
            cost: 15,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.SPACE, Tags_1.Tags.CITY],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(-18, { max: Options_1.max }); }),
            productionBox: Units_1.Units.of({ energy: -1, megacredits: 3 }),
            metadata: {
                cardNumber: 'Pf18',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.minus().production(function (pb) { return pb.energy(1); }).production(function (pb) { return pb.megacredits(3); }).br;
                    b.data().city().asterix();
                }),
                description: 'Temperature must be -18 C or lower. Decrease your energy production 1 step and ' +
                    'Raise your MC production 3 steps. Add 1 data to ANY CARD. Place a city tile on Mars NEXT TO NO OTHER TILE.',
            },
        }) || this;
    }
    EarlyExpedition.prototype.getAvailableSpaces = function (player) {
        return player.game.board.getAvailableSpacesOnLand(player)
            .filter(Board_1.nextToNoOtherTileFn(player.game.board));
    };
    EarlyExpedition.prototype.canPlay = function (player) {
        return player.canAdjustProduction(this.productionBox) && this.getAvailableSpaces(player).length > 0;
    };
    EarlyExpedition.prototype.play = function (player) {
        player.adjustProduction(this.productionBox);
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.DATA));
        return new SelectSpace_1.SelectSpace('Select place next to no other tile for city', this.getAvailableSpaces(player), function (foundSpace) {
            player.game.addCityTile(player, foundSpace.id);
            return undefined;
        });
    };
    return EarlyExpedition;
}(Card_1.Card));
exports.EarlyExpedition = EarlyExpedition;
